// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlipayCircleFilledSvg from "@ant-design/icons-svg/es/asn/AlipayCircleFilled";
import AntdIcon from '../components/AntdIcon';

var AlipayCircleFilled = function AlipayCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlipayCircleFilledSvg
  }));
};

AlipayCircleFilled.displayName = 'AlipayCircleFilled';
export default React.forwardRef(AlipayCircleFilled);